import { render, staticRenderFns } from "./center-chart.vue?vue&type=template&id=7f2fcadb&scoped=true&"
import script from "./center-chart.vue?vue&type=script&lang=js&"
export * from "./center-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2fcadb",
  null
  
)

export default component.exports